export const billingConstants = {
    GET_BILLING_SETTINGS_REQUEST: 'GET_BILLING_SETTINGS_LINK_REQUEST',
    GET_BILLING_SETTINGS_SUCCESS: 'GET_BILLING_SETTINGS_LINK_SUCCESS',
    GET_BILLING_SETTINGS_FAILURE: 'GET_BILLING_SETTINGS_LINK_FAILURE',
};
